import type { TMonitoringWeekday } from 'constants/interfaces/IMonitoringSchedule';

export const MONITORING_WEEKDAY_ORDER: TMonitoringWeekday[] = [
  'MO', 'TU', 'WE', 'TH', 'FR', 'SA', 'SU',
];

export const MONITORING_WEEKDAY_LABELS: Record<TMonitoringWeekday, string> = {
  MO: 'Mon',
  TU: 'Tue',
  WE: 'Wed',
  TH: 'Thu',
  FR: 'Fri',
  SA: 'Sat',
  SU: 'Sun',
};

export const MONITORING_SCHEDULE_FALLBACK_TIMEZONES = [
  'UTC',
  'America/New_York',
  'America/Chicago',
  'America/Denver',
  'America/Los_Angeles',
  'Europe/London',
  'Europe/Paris',
  'Europe/Berlin',
  'Asia/Tokyo',
  'Asia/Singapore',
  'Australia/Sydney',
];
